const DIGITAL_WALLETS_TRACKING_KEY = {
  AMAZON_PAY: 'amazonpay',
  ANDROID_PAY: 'androidpay',
  APPLE_PAY: 'apple pay',
  GOOGLE_PAY: 'gpay',
  PAY_PAL: 'paypal',
  SHOPIFY_PAY: 'shopay',
};

const DIGITAL_WALLETS_PROPS = {
  amazon_pay: {
    altText: 'Proceed with Amazon Pay',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.AMAZON_PAY,
    backgroundColor: '#fad676',
    isApplePay: false,
    isApplePayFriendly: false,
    logo: 'https://images.ctfassets.net/9uo1qvvet3xa/33RudJxATBd104HGRLDee7/b2c410059d5ba3cdef8fcbd4f8a5803c/Amazon_Pay_-_Black.svg',
  },
  android_pay: {
    altText: 'Proceed with Android Pay',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.ANDROID_PAY,
    backgroundColor: '',
    isApplePay: false,
    isApplePayFriendly: false,
    logo: '',
  },
  apple_pay: {
    altText: 'Proceed with Apple Pay',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.APPLE_PAY,
    backgroundColor: '#000000',
    isApplePay: true,
    isApplePayFriendly: true,
    logo: 'https://images.ctfassets.net/9uo1qvvet3xa/3DDS5hjUEljoau9dxGTHsz/aac3b6efbcbecdfb9c472304e5efa073/Apple_Pay_-_White.svg',
  },
  google_pay: {
    altText: 'Proceed with Google Pay',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.GOOGLE_PAY,
    backgroundColor: '#000000',
    isApplePay: false,
    isApplePayFriendly: false,
    logo: 'https://images.ctfassets.net/9uo1qvvet3xa/4mz6vy0p8adMSUKkW5qd7p/416938c3e395f691553ab47f0007f8b6/G_Pay.png',
  },
  paypal: {
    altText: 'Proceed with PayPal',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.PAY_PAL,
    backgroundColor: '#ffc439',
    isApplePay: false,
    isApplePayFriendly: true,
    logo: 'https://images.ctfassets.net/9uo1qvvet3xa/4dooJgkFpDR0AeMb4MKw8u/954fd7930cbc82523b57ef6e724be215/PayPal_-_Color.svg',
  },
  shopify_pay: {
    altText: 'Proceed with Shop Pay',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.SHOPIFY_PAY,
    backgroundColor: '#5a31f4',
    isApplePay: false,
    isApplePayFriendly: true,
    logo: 'https://images.ctfassets.net/9uo1qvvet3xa/6z90ekdLBJdFRPh7vo2wLh/2d4a0a4e96f3d7a19cea75f09cdc59ad/ShopPay_-_White.svg',
  },
};

export default DIGITAL_WALLETS_PROPS;
